import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { AppConfig } from '@core/token/app-config.token';
import { AppConfigModel } from '@utils/interfaces/app-config.model';
import { Observable } from 'rxjs';

import { APP } from '../app.constant';

import { LocalStorageService } from '../core/local-storage/local-storage.service';

@Injectable()
export class JwtInterceptor implements HttpInterceptor {
  constructor(
    @Inject(AppConfig) private config: AppConfigModel,
    private readonly localStorageService: LocalStorageService
  ) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const jwt: string | null = this.localStorageService.getItem(APP.AUTH.INFOR);
    const isApiUrl = request.url.startsWith(this.config.apiUrl);
    if (isApiUrl) {
      const headers: Record<string, string> = {};
      if (jwt) {
        headers['Authorization'] = `Bearer ${jwt}`;
      }
      if (Object.keys(headers).length > 0) {
        request = request.clone({ setHeaders: headers });
      }
    }

    return next.handle(request);
  }
}
